<template>
  <div class="plv-ia-qn-new-setting">
    <div class="plv-ia-qn-new-setting-title" ref="questionnaireNameInput" :class="{'plv-ia-qn-new-input--error': titleError}">
      <input
        class="plv-ia-qn-new-input plv-ia-qn-new-input--title"
        type="text"
        v-model="questionnaire.name"
        :placeholder="t('plvIA.questionnaire.questionnaireName')"
        :maxlength="maxLen.title"
        @change="titleError = false"
      />
    </div>
    <div class="plv-ia-qn-new-setting-introduce">
      <input
        class="plv-ia-qn-new-input"
        type="text"
        v-model="questionnaire.desc"
        :placeholder="t('plvIA.questionnaire.questionnaireDesc')"
        :maxlength="maxLen.title"
      />
    </div>
    <!-- 问题列表-->
    <div class="plv-ia-qn-new-setting-contain" ref="settingContain">
      <QuestionEdit
        v-for="(item, index) in questionnaire.questions"
        ref="questionEdit"
        :lang="lang"
        :questionData="item"
        :key="index + item.questionId + item.sortOrder"
        @update-data="(data) => updateQuestionData(index, data)"
        @delete="deleteQuestion(index)"
      />
      <p v-if="questionnaire.questions.length === 0"  class="plv-ia-qn-new-question--empty">
        <span class="plv-ia-qn-new-question-bottom-icon--tip"></span>
        {{ t('plvIA.questionnaire.questionEmpty') }}
      </p>
    </div>

    <div></div>
  </div>
</template>

<script>
import { maxLen, QUESTION_TYPE } from '@/assets/app/questionnaire/helper';
import QuestionEdit from './QuestionEdit';
import Locale from '@/mixins/locale';
export default {
  name: 'QuestionnaireSetting',
  components: {
    QuestionEdit
  },
  mixins: [Locale],
  props: {
    editingData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      maxLen,
      questionnaire: null,
      titleError: false,
    };
  },
  watch: {
    editingData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.questionnaire = val;
        this.questionnaire.questions.map((item, index) => {
          item.sortOrder = index;
          return item;
        });
      },
    }
  },
  methods: {
    updateQuestionData(index, data) {
      this.questionnaire.questions[index] = data;
    },
    deleteQuestion(index) {
      this.questionnaire.questions.splice(index, 1);
    },
    checkQuestionnaire() {
      const { editingData } = this;
      // 检查问卷名称是否为空
      if (editingData.name === '') {
        this.titleError = true;
        this.scrollToErrorDom(this.$refs.questionnaireNameInput);
        return false;
      } else {
        this.titleError = false;
      }
      // 检查问卷题目名称和选项是否为空
      for (let i = 0; i < editingData.questions.length; i++) {
        this.$refs.questionEdit[i].titleError = editingData.questions[i].name === '';
        if (this.$refs.questionEdit[i].titleError) {
          this.scrollToErrorDom(this.$refs.questionEdit[i].$el);
          return false;
        }
        const type = editingData.questions[i].type;
        // 评星题 问答不需要校验选项
        if (type === QUESTION_TYPE.STAR || type === QUESTION_TYPE.TEXT || type === QUESTION_TYPE.STAR_NUMBER) {
          continue;
        }
        // 单选题和多选题检查选项是否为空
        for (let j = 0; j < editingData.questions[i].options.length; j++) {
          const optionsError = this.$refs.questionEdit[i].optionsError;
          if (editingData.questions[i].options[j] === '') {
            this.$refs.questionEdit[i].optionsError.push(j);
            this.scrollToErrorDom(this.$refs.questionEdit[i].$el);
            return false;
          } else {
            optionsError.splice(optionsError.findIndex(item => item === j), 1);
          }
        }

      }
      return true;
    },
    // 滚动到错误输入框 dom节点
    scrollToErrorDom(dom) {
      dom.scrollIntoView();
    }
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-setting {
  height: 100%;
  flex: 1;
  padding: 16px;
  overflow: auto;
  box-sizing: border-box;
  .plv-ia-qn-new-question--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    color: #757575;
    .plv-ia-qn-new-question-bottom-icon--tip {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url('../images/icon-tip.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
.plv-ia-qn-new-setting-title {
  display: flex;
  justify-content: center;
}
.plv-ia-qn-new-setting-introduce {
  margin-top: 8px;
  .plv-ia-qn-new-input {
    text-align: center;
    color: #757575;
    box-sizing: border-box;
  }
}
.plv-ia-qn-new-input {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border: 1px solid #CFD8DC;
  padding: 0 4px;
  &:focus {
    outline: none;
    border-color: var(--interactBlue);
  }
}
.plv-ia-qn-new-input--title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.plv-ia-qn-new-input--error {
  input {
    outline-color: #FC1212 !important;
    border: 1px solid #FC1212;
  }
  input:focus {
    outline-color: #FC1212 !important;
    border: 1px solid #FC1212;
  }
}
</style>
